import type { RouteRecordRaw } from 'vue-router'
import FarmListView from '@/views/farm/FarmListView.vue'
import ExpensesView from '@/views/farm/ExpensesView.vue'
import YieldsView from '@/views/farm/YieldsView.vue'
import TransactionsView from '@/views/farm/TransactionsView.vue'
import YieldsHistory from '@/views/farm/YieldsHistory.vue'
interface RouteMeta {
  requiresAuth: boolean
  allowedRoles?: string[]
}
export const farmRoutes: Array<RouteRecordRaw & { meta: RouteMeta }> = [
  {
    path: '/supervisor/farm',
    name: 'FarmList',
    component: FarmListView,
    meta: { requiresAuth: true, allowedRoles: ['SUPERVISOR', 'ADMIN'] },
  },
  {
    path: '/supervisor/farm/expenses',
    name: 'FarmExpenses',
    component: ExpensesView,
    meta: { requiresAuth: true, allowedRoles: ['SUPERVISOR', 'ADMIN'] },
  },
  {
    path: '/farm/yields',
    name: 'FarmYields',
    component: YieldsView,
    meta: { requiresAuth: true, allowedRoles: ['SUPERVISOR', 'ADMIN'] },
  },
  {
    path: '/farm/yields-history',
    name: 'YieldsHistory',
    component: YieldsHistory,
    meta: { requiresAuth: true, allowedRoles: ['SUPERVISOR', 'ADMIN'] },
  },
  {
    path: '/farm/transactions',
    name: 'TransactionsView',
    component: TransactionsView,
    meta: { requiresAuth: true, allowedRoles: ['SUPERVISOR', 'ADMIN'] },
  },

]
